import React, { FC } from 'react'
import Toggle from '@vtex/styleguide/lib/Toggle'
import classNames from 'classnames'

const BOX_WIDTH = 292

export type MenuOption = {
  label: string
  onClick: (option: MenuOption) => void
  toggle?: {
    checked: boolean
    semantic: boolean
    handleChange: () => void
  }
  isDangerous: boolean
  enabled: boolean
}

type Props = {
  isOpen: boolean
  boxWidth: string | number
  options: MenuOption[]
  onMenuClose: () => void
  mediaQuery: (options: { phone: number; tablet: number }) => number
  align: 'right' | 'left'
}

const Menu: FC<Props> = ({ isOpen, boxWidth, options, onMenuClose, align }) => {
  const menuBtnRef = React.createRef<HTMLDivElement>()

  const handleClick = (event: React.SyntheticEvent, option: MenuOption) => {
    event.stopPropagation()
    option.onClick(option)
    if (onMenuClose) {
      onMenuClose()
    }
  }

  return (
    <div ref={menuBtnRef} className="relative">
      {isOpen && (
        <div
          className={`absolute z-999 ba b--muted-4 br2 shadow-1 mt4 menu-box-shadow ${
            align === 'right' ? 'right-0' : 'left-0'
          }`}
        >
          <div
            className="b2 br2 bg-base"
            style={{ width: boxWidth || BOX_WIDTH }}
          >
            <div className="min-h-100">
              {options.map((option, index) => (
                <div
                  key={index}
                  className={`menu-option-${index} flex justify-between ph6 pv3 pointer hover-bg-muted-5 c-on-base`}
                  onClick={(event) =>
                    option.enabled ? handleClick(event, option) : null
                  }
                >
                  <span
                    className={classNames({
                      'w-70 truncate': option.toggle,
                      'w-100 truncate': !option.toggle,
                      'c-muted-2': !option.enabled,
                      red: option.isDangerous,
                    })}
                  >
                    {option.label}
                  </span>
                  {option.toggle && (
                    <Toggle
                      size="small"
                      semantic={option.toggle.semantic}
                      checked={option.toggle.checked}
                      onChange={option.toggle.handleChange}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Menu
